export const phoneNumber = '+49 234 622094 00';
export const email = 'schaden@mobexo.de';